import React from 'react';
import EventChip from './EventChip';

const DayCell = ({
    dowLabel,
    dateLabel,
    ariaLabel,
    isOut,
    isToday,
    isMonthStart,
    events,
    onOpen,
}) => (
    <div
        className={`fc-day${isOut ? ' is-out' : ''}${isToday ? ' is-today' : ''}`}
        role="gridcell"
        aria-label={ariaLabel}
    >
        <div className="fc-day-head">
            {dowLabel ? <span className="fc-dow">{dowLabel}</span> : null}
            <span className={`fc-num${isToday ? ' is-today' : ''}${isMonthStart ? ' is-month' : ''}`}>{dateLabel}</span>
        </div>
        <div className="fc-day-events">
            {events.map((event) => (
                <EventChip key={event.id} event={event} onOpen={onOpen} />
            ))}
        </div>
    </div>
);

export default DayCell;
